import { render } from "./TagTable.vue?vue&type=template&id=3f8529d0&scoped=true"
import script from "./TagTable.vue?vue&type=script&lang=js"
export * from "./TagTable.vue?vue&type=script&lang=js"

import "./TagTable.vue?vue&type=style&index=0&id=3f8529d0&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8529d0"]])

export default __exports__